import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, withStyles } from '@material-ui/core';

const StyledTabs = withStyles(() => ({
  indicator: {
    display: 'none'
  }
}))((props) => <Tabs variant={'scrollable'} {...props} />);

const SimpleTabs = (props) => {
  return (
    <StyledTabs value={props.value} onChange={props.handleChange}>
      {props.children}
    </StyledTabs>
  );
};

SimpleTabs.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChange: PropTypes.func,
  children: PropTypes.node
};

export default SimpleTabs;
